import React, { useState } from 'react';
import {
  Container,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TextField,
  Button,
  IconButton,
  Pagination,
  Stack,
} from '@mui/material';
import { Edit, Delete, Check, Close } from '@mui/icons-material';

const CommonTable = ({
  data,
  columns,
  rowsPerPage,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  totalPage,
  setCurrentPage,
  currentPage,
  handlePageChange,
  searchTerm,
  setSearchTerm,
  handleSearch
}) => {
  const [editRowId, setEditRowId] = useState(null);
  const [editRowData, setEditRowData] = useState({});


  const totalPages = Math.ceil(totalPage / rowsPerPage);

  const handleEditClick = (row) => {
    setEditRowId(row.id);
    setEditRowData({ ...row });
    console.log(onEdit,"onEdit")
    if (onEdit) onEdit(row);
  };

  const handleSaveClick = () => {
    if (onSave) onSave(editRowData);
    setEditRowId(null);
  };

  const handleCancelClick = (originalRow) => {
    if (onCancel) onCancel(editRowId);
    setEditRowId(null);
    setEditRowData({ ...originalRow });
  };

  const handleDeleteClick = (rowId) => {
    if (onDelete) onDelete(rowId);

  };

  const handleInputChange = (e, accessor) => {
    setEditRowData({
      ...editRowData,
      [accessor]: e.target.value,
    });
  };

  // console.log(searchTerm,"searchTerm")
  return (
    <Container maxWidth="lg" sx={{ mt: 4,maxHeight: '70vh', overflow: 'auto' }}>
      <TextField
        fullWidth
        label="Search"
        variant="outlined"
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        sx={{ mb: 2,mt:4 }}
      />
      <TableContainer component={Paper} sx={{ boxShadow: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.accessor} sx={{ fontWeight: 'bold' }}>
                  {col.header}
                </TableCell>
              ))}
              <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.id}>
                  {columns.map((col) => (
                    <TableCell key={col.accessor}>
                      {editRowId === row.id && col.editable !== false ? (
                        <TextField
                          size="small"
                          value={editRowData[col.accessor] || ''}
                          onChange={(e) => handleInputChange(e, col.accessor)}
                        />
                      ) : (
                        row[col.accessor]
                      )}
                    </TableCell>
                  ))}
                  <TableCell>
                    {editRowId === row.id ? (
                      <>
                        <IconButton
                          color="success"
                          onClick={handleSaveClick}
                          sx={{ mr: 1 }}
                        >
                          <Check />
                        </IconButton>
                        <IconButton
                          color="secondary"
                          onClick={() => handleCancelClick(row)}
                        >
                          <Close />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <IconButton
                          color="primary"
                          onClick={() => handleEditClick(row)}
                          disabled={editRowId !== null}
                          sx={{ mr: 1 }}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteClick(row.id)}
                          disabled={editRowId !== null}
                        >
                          <Delete />
                        </IconButton>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 0 && (
        <Stack spacing={2} alignItems="center" sx={{ mt: 2,mb:10 }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
          />
        </Stack>
      )}
      
    </Container>
  );
};

export default CommonTable;
